export enum AngleConstants {
    Front = "Front",
    Perspective = "Perspective",
    Side = "Side",
    Detail = "Detail"
}
